import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

window.addEventListener('load', () => {
    const TL = gsap.timeline();
    if (document.querySelector('.button-home')) {
        TL.from('#header img', {autoAlpha: 0, y: -50, duration: .4, stagger: .1})
            .from('nav .pdw-mobile-menu-open', {autoAlpha: 0, y: -50, duration: 1}, '-=.2')
            .from('.page-title', {autoAlpha: 0, y: -50, duration: 1}, '-=.2')
            .from('.home-content', {autoAlpha: 0, y: -50, duration: 1}, '-=.2')
            .from('.button-home', {autoAlpha: 0, y: -50, duration: 1}, '-=.2')
        ;
    }
});

document.addEventListener("DOMContentLoaded", function () {
    gsap.registerPlugin(ScrollTrigger);
    let revealContainers = document.querySelectorAll(".reveal");
    if (document.getElementById('hero')) {
        gsap.utils.toArray("#hero > div").forEach((section, index) => {
            const image = section.querySelector(".hero-image");
            const content = section.querySelector(".hero-content");

            if (image) {
                gsap.set(image, {
                    opacity: 0.00042,
                    y: "-39.9832vh",
                    willChange: "opacity, transform",
                    transformStyle: "preserve-3d",
                });

                gsap.to(image, {
                    opacity: 1,
                    y: "0vh",
                    ease: "none",
                    scrollTrigger: {
                        trigger: section,
                        start: "top 90%",
                        end: "top 20%",
                        scrub: 3,
                    },
                });
            }

            if (content) {
                gsap.set(content, {
                    opacity: 0.00042,
                    filter: "blur(20px)",
                    willChange: "filter, transform",
                });

                gsap.to(content, {
                    opacity: 1,
                    filter: "blur(0px)",
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: section,
                        start: "top 60%",
                        end: "top 50%",
                        scrub: 2,
                    },
                });
            }
        });
    }

    if (revealContainers) {
        revealContainers.forEach((container) => {
            let image = container.querySelector("img");
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    start: "top 80%", // L'animation commence lorsque le haut du container atteint 80% de la fenêtre de visualisation
                    end: "bottom top", // L'animation continue jusqu'à ce que le bas du container atteigne le haut de la fenêtre
                    scrub: 1, // L'animation est synchronisée avec le défilement
                    toggleActions: "restart none none reset"
                }
            });

            tl.set(container, {autoAlpha: 1});
            tl.from(container, 1.5, {
                xPercent: -100,
                ease: "power2.out"
            });

            // Animer l'image avec un effet de taille et de mouvement
            tl.from(image, 1.5, {
                xPercent: 100,
                scale: 1.3,  // L'image commence agrandie
                delay: -1.5,
                ease: "power2.out"
            });

            // Ajouter une étape finale pour que l'image atteigne 100% à la fin de l'animation
            tl.to(image, {
                scale: 1, // L'image revient à sa taille d'origine
                duration: 1.5, // La durée du passage à 100% de la taille
                ease: "power2.out"
            });
        });
    }

});